/**
 * Helper function to determine
 * dimensions validation status and messages.
 */
export function dimensionsValidation(
  width,
  length,
  hasRubber,
  formElement,
  diameter
) {
  const priceBar = formElement.querySelector('.js-woo-price-bar')
  const wrapper = formElement.querySelector('.js-woo-additional-options')
  const min = parseFloat(priceBar.dataset.min)
  let max = parseFloat(priceBar.dataset.max)
  const rubberWidth = parseFloat(priceBar.dataset.rubberwidth)

  if (!priceBar || !min || !max) {
    return {
      status: false,
      message: 'Waardes konden niet worden opgehaald. Ververs de pagina.'
    }
  }

  if (hasRubber && !rubberWidth) {
    return {
      status: false,
      message: 'Rubberbreedte kon niet opgehaald worden.'
    }
  }

  const originalMax = max

  // Increase maximum if rubber_edge is checked
  if (hasRubber) {
    max = max + rubberWidth * 2
  } else {
    max = originalMax
  }

  if (!width || !length) {
    return {
      status: false,
      message: 'Voer het gewenste formaat in.'
    }
  } else if (width && length && (width < min || length < min)) {
    return {
      status: false,
      message: diameter
        ? `Vul een maat van minimaal ${min} cm in.`
        : `Vul maten van minimaal ${min} cm in.`
    }
  } else if (width && length && (width > max && length > max)) {
    return {
      status: false,
      message: diameter
        ? `De maat overschrijdt de maximale rolbreedte van ${max} cm.`
        : `Beide zijden overschrijden de maximale rolbreedte van ${max} cm.`
    }
  } else if (width && length && (width.includes(',') || length.includes(','))) {
    return {
      status: false,
      message: `Gebruik geen komma's (,) om getallen te scheiden maar een punt.`
    }
  } else {
    if (wrapper) {
      // Show next options if valid
      wrapper.classList.remove('inactive')
      wrapper.classList.add('active')
    }

    return {
      status: true,
      message: ''
    }
  }
}

/**
 * Helper function to determine
 * minimum and maximium validation message.
 */
export function dimensionsFeedback(
  width,
  length,
  hasRubber,
  formElement,
  diameter
) {
  const priceBar = formElement.querySelector('.js-woo-price-bar')
  const min = parseFloat(priceBar.dataset.min)
  let max = parseFloat(priceBar.dataset.max)
  const rubberWidth = parseFloat(priceBar.dataset.rubberwidth)
  const widthCheck = document.querySelector('.js-product-check-width')
  const lengthCheck = document.querySelector('.js-product-check-length')

  if (!priceBar || !min || !max) {
    return 'Waardes konden niet worden opgehaald. Ververs de pagina.'
  }

  if (hasRubber && !rubberWidth) {
    return {
      status: false,
      message: 'Rubberbreedte kon niet opgehaald worden.'
    }
  }

  const originalMax = max

  // Increase maximum if rubber_edge is checked
  if (hasRubber) {
    max = max + rubberWidth * 2
  } else {
    max = originalMax
  }

  if (width && length && (width < min || length < min)) {
    if (widthCheck && lengthCheck) {
      widthCheck.classList.remove('valid')
      lengthCheck.classList.remove('valid')
    }

    return diameter
      ? `Vul een maat van minimaal ${min} cm in.`
      : `Vul maten van minimaal ${min} cm in.`
  } else if (width && length && (width > max && length > max)) {
    if (widthCheck && lengthCheck) {
      widthCheck.classList.remove('valid')
      lengthCheck.classList.remove('valid')
    }

    return diameter
      ? `De maat overschrijdt de maximale rolbreedte van ${max} cm. <a href="/klantenservice" target="_blank">Neem contact met ons op</a> om je wensen te bespreken.`
      : `Beide zijden overschrijden de maximale rolbreedte van ${max} cm. <a href="/klantenservice" target="_blank">Neem contact met ons op</a> om je wensen te bespreken.`
  } else if (width && length && (width.includes(',') || length.includes(','))) {
    if (widthCheck && lengthCheck) {
      widthCheck.classList.remove('valid')
      lengthCheck.classList.remove('valid')
    }

    return `Gebruik geen komma's (,) om getallen te scheiden maar een punt.`
  } else if (width && length) {
    const rubber = formElement.querySelector('.js-options-rubber')
    if (rubber) {
      rubber.classList.remove('active-error')
      rubber.classList.add('active')
    } else {
      const extras = formElement.querySelector('.js-options-extras')
      if (extras) {
        extras.classList.remove('inactive')
        extras.classList.add('active')
      }
    }

    if (widthCheck && lengthCheck) {
      widthCheck.classList.add('valid')
      lengthCheck.classList.add('valid')
    }

    const fillingMat = formElement.querySelector('.js-woo-filling-mat');
    if (fillingMat) {
      fillingMat.classList.remove('inactive')
      fillingMat.classList.add('active')
    }

    const additionalProducts = formElement.querySelector('.js-woo-additional-products');
    if (additionalProducts) {
      additionalProducts.classList.remove('inactive')
      additionalProducts.classList.add('active')
    }

    return ''
  } else {
    return ''
  }
}



// WEBPACK FOOTER //
// ./src/js/woocommerce/DimensionsValidation.js